import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { Provider } from "react-redux";
import store from './store';
import { toggleDebug } from './store/app/actions';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { muiTheme } from './config';
// import { runLiveTicketTest } from './test/live_ticket';
import './helpers/axiosInterceptor';


/** GLOBAL VARIABLES */
window.toggleDebugMode = () => toggleDebug(store.dispatch, store.getState);

const render = (
    <Provider store={store}>
        <MuiThemeProvider theme={muiTheme}>
            <App />
        </MuiThemeProvider>
    </Provider>
)
ReactDOM.render(render, document.getElementById('root'));

/** run global tests here */
// runLiveTicketTest({maxTickets: 10});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
